define('lq/events/actions/mollieUpdateCustomer',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function MollieUpdateCustomer(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(MollieUpdateCustomer, EventAction);

    MollieUpdateCustomer.typeName = 'MollieUpdateCustomer';

    MollieUpdateCustomer.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    MollieUpdateCustomer.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "UpdateMollieCustomer",
            commandId: this.eventData.command
        };
    };

    return MollieUpdateCustomer;
});
